var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e-chip-status text-12px",style:(_vm.styles)},[_vm._v(_vm._s(_vm.status.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }